import styled from "styled-components";

export const Game = styled.iframe`
  width: 100vw;
  height: 100vh;
  border: 0 solid transparent;
`;
